// extracted by mini-css-extract-plugin
module.exports = {"btn":"ButtonSmall_btn__16ABy"};